import PropTypes from 'prop-types';
import React from 'react';
import checkedIcon from './assets/form-checkbox-checked.svg';
import { pure } from 'recompose';
import uncheckedIcon from './assets/form-checkbox-unchecked.svg';

const Checkbox = ({ checked, onChange }) => (
  <img
    alt=""
    className="checkbox"
    src={checked ? checkedIcon : uncheckedIcon}
    onClick={onChange}
  />
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func
};

Checkbox.defaultProps = {
  checked: false,
  onChange: () => {}
};

export default pure(Checkbox);



// WEBPACK FOOTER //
// ./src/components/elements/Checkbox/index.js